import { Link } from "react-router-dom";

interface AnimeCardProps {
  anime: {
    id: string;
    title: string;
    cover: string;
    genres: string[];
    rating: number;
    status: string;
    year: number;
  };
}

export default function AnimeCard({ anime }: AnimeCardProps) {
  return (
    <Link
      to={`/anime/detail/${anime.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors wf-fade-up"
      data-product-shop
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={anime.cover}
          alt={`${anime.title} 动漫作品封面`}
          title={`${anime.title} - 火狼动漫网热门动漫推荐`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-primary-950 text-xs font-bold whitespace-nowrap">
          {anime.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-2 left-2 px-2 py-0.5 rounded-md bg-primary-950/75 text-background-50 text-xs font-medium whitespace-nowrap">
          {anime.status}
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors truncate">
          {anime.title}
        </h3>
        <div className="mt-2 flex items-center flex-wrap gap-1">
          {anime.genres.slice(0, 2).map((g) => (
            <span
              key={g}
              className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900 text-[11px] whitespace-nowrap"
            >
              {g}
            </span>
          ))}
          <span className="text-[11px] text-foreground-400 ml-auto">{anime.year}</span>
        </div>
      </div>
    </Link>
  );
}